import CustomForm from "../CustomForm";
import ICustomFormSettings from "../ICustomFormSettings";
import m, {Vnode} from "mithril";
import {LabelItem} from "../../model/items/labelItem";
import NumericScaleItem from "../shared/components/NumericScaleItem/NumericScaleItem";
import {RadioItem} from "../../model/items/radio";
import RadioCell from "../shared/components/FormCell/RadioCell";

export abstract class Nps extends CustomForm
{
    protected readonly variableName: string;
    protected errorMessage: string|null = null;

    protected readonly labels: LabelItem[] = [];
    protected npsItem!: NumericScaleItem;
    protected readonly radioItems: RadioItem[] = [];
    protected dontKnow?: RadioCell;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        this.variableName = Object.keys(this.settings.form.variables)[0];
        for (const cell of settings.form.grid.cells) {
            for (const cellItem of cell.cellItems) {
                if (cellItem instanceof LabelItem) {
                    if (cell.row < 5) {
                        this.labels[0] = cellItem;
                    } else {
                        this.labels[1] = cellItem;
                    }
                } else if (cellItem instanceof RadioItem) {
                    if (cellItem.getValue() === '99') {
                        this.dontKnow = new RadioCell(cell, this.onSetValue.bind(this));
                    } else {
                        this.radioItems.push(cellItem);
                    }
                }
            }
        }
    }

    public rewriteFormControls(): boolean {
        return true;
    }

    public checkRequirements(): boolean
    {
        const form = this.settings.form;

        if (Object.keys(form.variables).length === 0) {
            console.log('customForm-Nps: expect at least one variable');
            return false;
        }

        return true;
    }

    public view(): Vnode {
        return this.viewLayout([
            this.viewHeroImage(),
            m('.answers', {}, [
                m(this.npsItem),
                this.dontKnow ? m(this.dontKnow) : null,
            ]),
            m('.hint', {}, this.settings.form.questionary.messages.get('selectRecommendationRate')),
            this.errorMessage ? m("div.error-alert", this.errorMessage) : null
        ]);
    }


}